module.exports = __webpack_public_path__ + "static/img/button-start-active-2.461a4a5.webp";